import { Component, Input, ViewEncapsulation } from '@angular/core';

/**
 * Every back-office screen's title block: optional back link, icon + title, subtitle,
 * and actions on the right that wrap underneath on narrow screens.
 *
 *   <lb-page-header title="Purchase orders" icon="fa-file-text-o" subtitle="...">
 *     <button lbActions class="btn btn-primary">New</button>
 *   </lb-page-header>
 */
@Component({
  selector: 'lb-page-header',
  encapsulation: ViewEncapsulation.None,
  template: `
    <header class="lb-page-header">
      <div class="lb-page-header-text">
        <a *ngIf="backLink" class="lb-page-header-back" [routerLink]="backLink" [queryParams]="backQueryParams">
          <i class="fa fa-arrow-left" aria-hidden="true"></i> {{ backLabel }}
        </a>
        <h1 class="lb-page-title">
          <i *ngIf="icon" class="fa" [ngClass]="icon" aria-hidden="true"></i>
          <span>{{ title }}</span><ng-content select="[lbTitle]"></ng-content>
        </h1>
        <div class="lb-page-subtitle" *ngIf="subtitle">{{ subtitle }}</div>
        <ng-content select="[lbSubtitle]"></ng-content>
      </div>
      <div class="lb-page-actions">
        <ng-content select="[lbActions]"></ng-content>
      </div>
    </header>
  `,
  styles: [`
    .lb-page-header {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-end;
      justify-content: space-between;
      gap: var(--lb-space-3) var(--lb-space-4);
      margin-bottom: var(--lb-space-4);
    }
    .lb-page-header-text {
      min-width: 0;
      flex: 1 1 18rem;
    }
    .lb-page-header-back {
      display: inline-block;
      margin-bottom: var(--lb-space-1);
      text-decoration: none;
      font-size: 0.9rem;
    }
    .lb-page-title {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      margin: 0;
      font-size: 1.5rem;
      font-weight: 600;
      color: var(--lb-text);
      overflow-wrap: anywhere;
    }
    .lb-page-subtitle {
      color: var(--lb-text-muted);
      margin-top: 0.15rem;
    }
    .lb-page-actions {
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: var(--lb-space-2);
    }
    .lb-page-actions:empty {
      display: none;
    }
    @media (max-width: 575.98px) {
      .lb-page-title {
        font-size: 1.3rem;
      }
      .lb-page-actions {
        width: 100%;
      }
      /* The page's action is full width on a phone, easy to reach with a thumb */
      .lb-page-actions > .btn {
        flex: 1 1 auto;
      }
    }
  `]
})
export class LbPageHeaderComponent {
  @Input() title = '';
  @Input() icon = '';
  @Input() subtitle = '';
  @Input() backLink: string | any[] | null = null;
  @Input() backLabel = 'Back';
  @Input() backQueryParams: { [key: string]: any } | null = null;
}
